import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Label,
} from "recharts";

const LineAxisChart = ({ borrowerGrowthStatistics }) => {
  return (
    <ResponsiveContainer width="100%" height={250}>
      <LineChart
        data={borrowerGrowthStatistics}
        margin={{ top: 0, right: 10, left: 0, bottom: 15 }}
      >
        <XAxis
          dataKey="month"
          axisLine={{ stroke: "#D9D9D9" }}
          tickFormatter={(value) => String(value).slice(0, 3)}
        >
          <Label value="Months" position="insideBottom" offset={-10} />
        </XAxis>
        <YAxis axisLine={{ stroke: "#D9D9D9" }} />
        <Tooltip cursor={false} />
        <Line
          type="linear"
          dataKey="growthRate"
          stroke="#074073"
          strokeWidth={1}
          dot={false}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default LineAxisChart;
